import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ProjetoCadastro } from '../../../models/projeto-cadastro.model';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ProjetoEquipeCapacidadeExecucaoService } from '../../../services/projeto-equipe-capacidade-execucao.service';
import { AtualizacoesAudit } from '../../../models/atualizacoes-audit.model';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { environment } from 'src/environments/environment';
import { ProjetoCadastroService } from '../../../services/projeto-cadastro.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-capacidade-execucao-edit',
  templateUrl: './capacidade-execucao-edit.component.html',
  styleUrls: ['./capacidade-execucao-edit.component.scss'],
})
export class CapacidadeExecucaoEditComponent
  extends BaseFormComponent<ProjetoCadastro>
  implements OnInit
{
  actionLabel: string = 'Nova';
  idProjeto: any;
  @Input() projeto: ProjetoCadastro;
  @Input() equipeReadyList: Array<{ id: number; label: string }>;
  @Input() permissoes: any;
  audit: AtualizacoesAudit;
  modalCloneRef?: BsModalRef;
  clone_title: string;

  @ViewChild('modalClone') modalClone: TemplateRef<any>;

  constructor(
    private myService: ProjetoEquipeCapacidadeExecucaoService,
    private projetoService: ProjetoCadastroService,
    public activatedRoute: ActivatedRoute,
    private modalService: BsModalService,
    private navigation: NavigationService
  ) {
    super(activatedRoute);
  }

  ngOnInit(): void {
    this.loaded();

    if (this.projeto) {
      this.idProjeto = this.projeto.id;
    }
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      ds_agency: new FormControl('', [Validators.maxLength(1000)]),
      ds_organization: new FormControl('', [Validators.maxLength(1000)]),
      equip_ready: new FormControl('', Validators.required),
    });

    if (!this.permissoes.canSave) {
      this.form.get('ds_agency').disable();
      this.form.get('ds_organization').disable();
      this.form.get('equip_ready').disable();
    }

    this.form.get('equip_ready')?.setValue(this.equipeReadyList?.[0].id);

    if (this.projeto) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.projeto);

      this.audit = {
        pp_id: this.projeto.id,
      };
    }
  }

  voltar() {
    this.navigation.back(['pre-projeto/projeto/']);
  }

  getDataCreate(): ProjetoCadastro {
    let data: ProjetoCadastro;
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.projeto?.id) {
        this.addSub(
          this.myService
            .updateCapacidade(this.getDataCreate(), this.projeto?.id)
            .subscribe({
              next: (res: ProjetoCadastro) => {
                this.msgSuccess('Cadastro alterado com sucesso!');
                EventSharedService.get('auditRefresh').emit();
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error.message);
                this.loaded();
              },
            })
        );
      }
    } else {
      this.markAsDirty();
    }
  }

  confirmExcluir() {
    this.alertConfirmation(null, 'Tem certeza que deseja excluir o projeto?').subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir(): void {
    this.loading();
    this.projetoService.delete(this.idProjeto).subscribe({
      next: () => {
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.navigation.replace(['/pre-projeto', 'projeto']);
        });
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error);
      },
    });
  }

  closeCloneModal() {
    this.modalCloneRef?.hide();
  }

  openCloneModal() {
    this.clone_title = '';
    this.modalCloneRef = this.modalService.show(this.modalClone);
  }

  clonar() {
    this.closeCloneModal();
    this.loading();
    if (this.idProjeto && this.permissoes.canClone) {
      const obj = {
        clone_id: this.idProjeto,
        clone_title: this.clone_title,
      };
      this.addSub(
        this.projetoService.clonar(obj).subscribe({
          next: () => {
            this.msgSuccess('Clonado com sucesso!');
            this.loaded();
          },
          error: (error) => {
            this.msgError(error?.error?.message);
            this.loaded();
          },
        })
      );
    }
  }

  imprimir() {
    this.loading();
    const url = `${environment.serverUrl}/rest/pre-projeto/relatorio/${this.idProjeto}`;
    this.loaded();
    window.open(url, '_blank');
  }
}
